<div>
  <p ng-if="registro.objeto.temTarefa">
    <b>Essa ocorrência gerou uma tarefa para {{registro.objeto.responsavel.nome | humanize}}</b>
  </p>
  <p>
    {{registro.objeto.acao}}
  </p>
  <p ng-if="registro.dataRegistro">Data do Registro: {{registro.dataRegistro | date: 'dd/MM/yyyy'}}</p>
</div>
